import { render, staticRenderFns } from "./Kataloganfordern.vue?vue&type=template&id=e21e500a&scoped=true&"
import script from "./Kataloganfordern.vue?vue&type=script&lang=js&"
export * from "./Kataloganfordern.vue?vue&type=script&lang=js&"
import style0 from "./Kataloganfordern.vue?vue&type=style&index=0&id=e21e500a&lang=scss&scoped=true&"
import style1 from "./Kataloganfordern.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21e500a",
  null
  
)

export default component.exports